import { IAgencyOverride } from '../../shared/types/api/user.type'
import { IRequestEquipment } from '../types/equipment.type'
import { IRequestFrequencyExclusion } from '../types/exercise.type'
import { IHopset } from '../types/spectrum-manager.type'
import { ISFAFContents, ISFAFFrequency, SFAFStationClassType, SFAFAntennaType, SFAFObject } from '../types/sfaf.type'
import {
  applyAgencyAndAdminFields,
  applyAntennaOverrides,
  applyClassificationAndIdentifiers,
  applyEquipmentAndStations,
  applyLocations,
  applyRadiusOverrideLogic,
  applyHopset,
} from './sfaf-appliers'

export function get_sfaf_data(
  sfaf_obj: SFAFObject,
  frequency: ISFAFFrequency,
  sfafContents: ISFAFContents[],
  excludedFrequencies: IRequestFrequencyExclusion[],
  equipments: IRequestEquipment[],
  stationClasses: SFAFStationClassType[],
  antennas: SFAFAntennaType[],
  hopset: IHopset | null,
  agencyOverride?: IAgencyOverride | null,
) {
  applyClassificationAndIdentifiers(sfaf_obj, frequency, sfafContents, excludedFrequencies, agencyOverride)
  applyLocations(sfaf_obj, frequency)
  const radiusData = applyEquipmentAndStations(sfaf_obj, frequency, equipments, stationClasses, antennas)
  applyRadiusOverrideLogic(sfaf_obj, frequency, radiusData)
  applyAntennaOverrides(sfaf_obj, frequency)
  const sfafContent = sfafContents.find((c) => c.id === frequency.request_frequency_request_id)
  if (sfafContent) {
    applyAgencyAndAdminFields(sfaf_obj, frequency, sfafContent, agencyOverride)
  }
  if (hopset) applyHopset(sfaf_obj, frequency, hopset)
}
